import { type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import type { BondRequestPreview } from "../../bond-request/agent/types";
import { bondRequestPreviewsQueryKey } from "../bond-request.keys";

export const useAdminFetchAccountBondRequestPreviews = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondRequestPreviewsQueryKey(accountId),
		queryFn: async () =>
			await get<BondRequestPreview[]>(`/v2/admin/surety/accounts/${accountId}/quotes/previews`),
		staleTime: 1000 * 60 * 5,
	});

	return {
		adminAccountBondRequestPreviews: data,
		adminAccountBondRequestPreviewsError: error,
		adminAccountBondRequestPreviewsIsLoading: isLoading,
	};
};
